import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get, filter, map, size, includes } from "lodash";

import { getLov } from "../../utils/lov";

import Box from "@material-ui/core/Box";

import Loader from "../Common/Loader";
import ProfileViewMatched from "./ProfileView/ProfileViewMatched";
import ProfileForm from "./ProfileForm/ProfileForm";

import colors from "../../assets/style/colors";

const styles = (theme) => ({
  card: {
    backgroundColor: colors.white,
    overflow: "auto",
    borderRadius: "2px",
    [theme.breakpoints.up("sm")]: {
      maxHeight: "calc(100vh - 200px)",
      height: "calc(100vh - 200px)",
      margin: "12px",
      boxShadow: "0px 2px 2px 0px " + colors.black23,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "12px 6px",
      maxHeight: "calc(100vh - 160px)",
      height: "calc(100vh - 160px)",
    },
  },
});

const ProfileDetails = (props) => {
  const {
    classes,
    profile,
    refresh,
    profileAttributes,
    permissions,
    isMe,
  } = props;
  const images = profile.images || [];
  const profileType = profile.profile_type_id;
  const [editMode, setEditMode] = React.useState(false);
  const [lov, setLov] = React.useState({});

  React.useEffect(() => {
    const fetchLov = async () => {
      try {
        let lovAttributes = map(
          filter(profileAttributes, (attr) =>
            includes(["radiobutton", "lov(picker)"], get(attr, ["data_type"]))
          ),
          (attr) => attr.id
        );
        let lov = {
          tag: await getLov("tags"),
        };
        for (let i = 0; i < size(lovAttributes); i++) {
          let attr = get(lovAttributes, [i]);
          lov[attr] = await getLov(attr);
        }
        setLov(lov);
      } catch (e) {
        console.log(e);
      }
    };
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileAttributes]);

  const getProfilePhotos = () => {
    if (profileType === 1) {
      return images.filter((img) => img.enrollment_status === true);
    }
    return images;
  };

  if (!images || !profile) {
    return <Loader height="250px" noDecoration />;
  }

  return (
    <Box className={classes.card}>
      {!editMode ? (
        <ProfileViewMatched
          profileType={profileType}
          profile={profile}
          lov={lov}
          edit={() => setEditMode(true)}
          photos={getProfilePhotos()}
          profileAttributes={profileAttributes}
          isMe={isMe}
          permissions={permissions}
          refresh={refresh}
        />
      ) : (
        <ProfileForm
          profileType={profileType}
          profile={{ ...profile, sys_tag_id: profile.tag_id }}
          setCreatedProfile={() => {
            setEditMode(false);
            refresh();
          }}
          close={() => setEditMode(false)}
          disablePhotos={true}
          permission={profile.meta.pii_permission}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

PropTypes.ProfileDetails = {
  profile: PropTypes.object.isRequired,
  refresh: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileDetails));
